export const AccountTypeOptions = {
    PAYMENTS: `payments`,
    PAYOUTS: `payout`,
    COLLECT: `collect`,
    CORPORATE: `corporate`
}